import { render, staticRenderFns } from "./AssignTeacherPopover.vue?vue&type=template&id=048b77ce&scoped=true&"
import script from "./AssignTeacherPopover.vue?vue&type=script&lang=js&"
export * from "./AssignTeacherPopover.vue?vue&type=script&lang=js&"
import style0 from "./AssignTeacherPopover.vue?vue&type=style&index=0&id=048b77ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b77ce",
  null
  
)

export default component.exports